export * from './lib/components/input-incrementor/input-incrementor.component';
export * from './lib/core-ui-input-incrementor.module';
